/** Country flag emoji mapping for JA Lab competitions (22/09/2026).
 *  Used as visual identity when competition.logo_url is NULL in DB.
 *  NOT a substitute for real logos -- just a clean fallback. */

const COUNTRY_FLAGS: Record<string, string> = {
  // Europe
  'England': '\u{1F1EC}\u{1F1E7}',
  'Spain': '\u{1F1EA}\u{1F1F8}',
  'Italy': '\u{1F1EE}\u{1F1F9}',
  'Germany': '\u{1F1E9}\u{1F1EA}',
  'France': '\u{1F1EB}\u{1F1F7}',
  'Netherlands': '\u{1F1F3}\u{1F1F1}',
  'Portugal': '\u{1F1F5}\u{1F1F9}',
  'Belgium': '\u{1F1E7}\u{1F1EA}',
  'Scotland': '\u{1F1F8}\u{1F1EC}',
  'Turkey': '\u{1F1F9}\u{1F1F7}',
  'Greece': '\u{1F1EC}\u{1F1F7}',
  'Czech Republic': '\u{1F1E8}\u{1F1FF}',
  'Croatia': '\u{1F1ED}\u{1F1F7}',
  'Serbia': '\u{1F1F7}\u{1F1F8}',
  'Switzerland': '\u{1F1E8}\u{1F1ED}',
  'Austria': '\u{1F1E6}\u{1F1F9}',
  'Poland': '\u{1F1F5}\u{1F1F1}',
  'Denmark': '\u{1F1E9}\u{1F1F0}',
  'Sweden': '\u{1F1F8}\u{1F1EA}',
  'Norway': '\u{1F1F3}\u{1F1F4}',
  'Ukraine': '\u{1F1FA}\u{1F1E6}',
  'Ireland': '\u{1F1EE}\u{1F1EA}',
  // Americas
  'Argentina': '\u{1F1E6}\u{1F1F7}',
  'Brazil': '\u{1F1E7}\u{1F1F7}',
  'USA': '\u{1F1FA}\u{1F1F8}',
  'Mexico': '\u{1F1F2}\u{1F1FD}',
  'Colombia': '\u{1F1E8}\u{1F1F4}',
  'Chile': '\u{1F1E8}\u{1F1F1}',
  'Uruguay': '\u{1F1FA}\u{1F1FE}',
  'Ecuador': '\u{1F1EA}\u{1F1E8}',
  'Paraguay': '\u{1F1F5}\u{1F1FE}',
  'Peru': '\u{1F1F5}\u{1F1EA}',
  'MLS': '\u{1F1FA}\u{1F1F8}',
  // Africa
  'Morocco': '\u{1F1F2}\u{1F1E6}',
  'Egypt': '\u{1F1EA}\u{1F1EC}',
  'South-Africa': '\u{1F1FF}\u{1F1E6}',
  'Nigeria': '\u{1F1F3}\u{1F1EC}',
  // Asia
  'Japan': '\u{1F1EF}\u{1F1F5}',
  'South-Korea': '\u{1F1F0}\u{1F1F7}',
  'China': '\u{1F1E8}\u{1F1F3}',
  // Continental
  'Europa': '\u{1F30D}',
}

export function getCountryFlag(country: string | null | undefined): string {
  if (!country) return '\u{1F30D}'
  return COUNTRY_FLAGS[country] ?? '\u{1F30D}'
}
